import React from 'react';
import { Box, Modal, Grid, Zoom } from '@mui/material';
import {
    CancelButton, DataInputForm, InputBox, ModalLabel,
    modalStyle, TextFieldBox, TextFieldForm, TextFieldLabel,
    SaveButton
} from './saveCondition.styles';
import SwalUtil from '../../shared/util/sweetalert/sweetalertUtil';
import { BackdropLoading } from '../../shared/spinner/backdropLoading';
import { SearchCrudApiRequest } from '../../shared/model/apiRequestModel';
import { fetchAuthSession } from 'aws-amplify/auth';
import crud from '../../shared/api/crud';
import { SystemErrorMsg, SystemErrorTitle } from '../../constants';
import { useNavigate } from 'react-router-dom';
import { sessionDisconnectedCheck } from '../../shared/api/sessionDisconnectedCheck';

interface OwnProps {
    isOpen: boolean,
    searchConditon: string,
    handleClose: (isOpen: boolean) => void
}

const screenId = "U041"

const SaveCondition = (props: OwnProps) => {
    const navigate = useNavigate();
    const { isOpen, searchConditon, handleClose } = props
    const [open, setOpen] = React.useState(isOpen);
    const [coditionsName, setCoditionsName] = React.useState("");
    const [loading, setLoading] = React.useState<boolean>(false);

    React.useEffect(() => {
        setOpen(isOpen)
        if (!isOpen) {
            setCoditionsName("")
        }
    }, [isOpen])

    const getDataListCount = async () => {
        setLoading(true)
        const session = await fetchAuthSession();
        const email = session.tokens?.idToken?.payload?.email?.toString() || '';
        const sessionId = session.tokens?.idToken?.payload?.sessionId?.toString() || '';
        const accountInfoData = JSON.parse(session.tokens?.idToken?.payload?.accountInfoData?.toString() || "[]");
        const contract = JSON.parse(session?.tokens?.idToken?.payload.contractInfoData?.toString() || "[]");
        const contractForm = contract.length !== 0 && contract[0].contractForm;
        const request: SearchCrudApiRequest = {
            sessionId: sessionId,
            userMailAddress: email,
            processFlag: "0",
            countFlag: "1",
            contractForm: contractForm,
            targetTableName: "T_SAVE_INPUT_DATA",
            selectItems: [],
            conditions: [
                {
                    targetColumn: "MAIL_ADDRESS",
                    targetValue: [email]
                }
            ],
            conditionsOperator: 'and',
            orderBy: [],
            usingStartDate: contract.length !== 0 && accountInfoData[0].usingStartDate
        }

        const response = crud(request);
        const resCd = (await response).resCd;
        setLoading(false)
        if (resCd === 'I0000') {
            const resCount = (await response).data?.resultData[0]['COUNT(*)'];
            return resCount;
        } else {
            navigate("/Error", { state: { title: SystemErrorTitle, message: SystemErrorMsg } });
        }
    };

    const handleSave = async () => {
        // セッションの有効性確認
        if (await sessionDisconnectedCheck(screenId, "handleSave", navigate)) {
            return
        }
        // 保存名チェック
        let numberOfSavedConditions = await getDataListCount()
        if (numberOfSavedConditions === undefined) {
            return
        }
        if (coditionsName === '') {
            SwalUtil.labelInfo({
                title: "保存名未入力",
                message: "保存名を入力してください",
                icon: "error",
                confirmButtonText: "OK",
                buttonAlign: "right",
            });
        } else if (coditionsName.length > 60) {
            SwalUtil.labelInfo({
                title: "保存名文字上限",
                message: "保存名は60文字以内で入力してください",
                icon: "error",
                confirmButtonText: "OK",
                buttonAlign: "right",
            });
        } else if (numberOfSavedConditions >= 20) {
            SwalUtil.labelInfo({
                title: "登録件数上限",
                message: "登録可能な入力データは20件までです<br>検索条件の読込・削除ボタンより、<br>不要な入力データの削除をお願いします",
                icon: "error",
                confirmButtonText: "OK",
                buttonAlign: "right",
            });
        } else {
            setLoading(true)
            const createNewInputDataSave = async () => {
                const session = await fetchAuthSession();
                const email = session.tokens?.idToken?.payload?.email?.toString() || '';
                const sessionId = session.tokens?.idToken?.payload?.sessionId?.toString() || '';
                const accountInfoData = JSON.parse(session.tokens?.idToken?.payload?.accountInfoData?.toString() || "[]");
                const contract = JSON.parse(session?.tokens?.idToken?.payload.contractInfoData?.toString() || "[]");
                const contractForm = contract.length !== 0 && contract[0].contractForm;
                const nowDate = new Date();
                const jstDate = formatDate(nowDate.toString())
                const request: SearchCrudApiRequest = {
                    sessionId: sessionId,
                    userMailAddress: email,
                    processFlag: "1",
                    countFlag: "0",
                    contractForm: contractForm,
                    targetTableName: "T_SAVE_INPUT_DATA",
                    selectItems: [],
                    conditions: [
                        {
                            targetColumn: "MAIL_ADDRESS",
                            targetValue: [email]
                        },
                        {
                            targetColumn: "SAVE_NAME",
                            targetValue: [coditionsName]
                        },
                        {
                            targetColumn: "SEARCH_CONDITIONS",
                            targetValue: [searchConditon]
                        },
                        {
                            targetColumn: "TOROKU_DATE",
                            targetValue: [jstDate]
                        },
                        {
                            targetColumn: "TOROKU_KINO_ID",
                            targetValue: [screenId]
                        },
                        {
                            targetColumn: "KOSHIN_DATE",
                            targetValue: [jstDate]
                        },
                        {
                            targetColumn: "KOSHIN_KINO_ID",
                            targetValue: [screenId]
                        },
                        {
                            targetColumn: "VERSION_NO",
                            targetValue: ['1']
                        },
                        {
                            targetColumn: "SAKUJO_FLAG",
                            targetValue: ['0']
                        }
                    ],
                    conditionsOperator: 'and',
                    orderBy: [],
                    usingStartDate: contract.length !== 0 && accountInfoData[0].usingStartDate
                }

                const response = crud(request);
                const resCd = (await response).resCd;
                setLoading(false);
                if (resCd === 'I0000') {
                    SwalUtil.labelInfo({
                        title: "保存完了",
                        message: '入力データの保存が完了しました',
                        confirmButtonText: "OK",
                        buttonAlign: "right",
                        buttonOrder: { confirm: 2, deny: 1 }
                    }).then((result) => {
                        if (result.isConfirmed) {
                            setCoditionsName('')
                            handleClose(false)
                        }
                    });
                } else {
                    navigate("/Error", { state: { title: SystemErrorTitle, message: SystemErrorMsg } });
                }
            };
            createNewInputDataSave()
        }
    }

    const formatDate = (strDate: string) => {
        const date = new Date(strDate)
        return date.toLocaleDateString('ja-JP', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        });
    }

    const handleChange = (v: string) => {
        setCoditionsName(v)
    }

    return (
        <>
            <BackdropLoading open={loading} />
            <Modal
                open={open}
                onClose={handleClose}
                closeAfterTransition
                sx={{
                    zIndex: 900
                }}
                slotProps={{
                    backdrop: {
                        sx: {
                            zIndex: 900
                        }
                    }
                }}
            >
                <Zoom
                    in={open}
                    style={{ zIndex: 1000, transformOrigin: '-50% -50% -50%' }}
                    easing={{
                        enter: "cubic-bezier(0, 1.45, 0.62, 1)",
                        exit: "linear"
                    }}
                >
                    <Box sx={modalStyle} tabIndex={-1}>
                        <ModalLabel>
                            検索条件の保存
                        </ModalLabel>
                        <InputBox>
                            <TextFieldBox border={1}>
                                <Grid container>
                                    <TextFieldLabel size={3}>保存名</TextFieldLabel>
                                    <TextFieldForm size={9}>
                                        <DataInputForm placeholder="データ保存名を入力" fullWidth variant='outlined' size='small' onChange={(e) => handleChange(e.target.value)} />
                                    </TextFieldForm>
                                </Grid>
                            </TextFieldBox>
                        </InputBox>
                        <Box>
                            <Grid container sx={{ width: '98%' }}>
                                <Grid size={6} />
                                <Grid size={3}>
                                    <CancelButton variant="contained" onClick={() => handleClose(false)}>キャンセル</CancelButton>
                                </Grid>
                                <Grid size={3}>
                                    <SaveButton variant="contained" onClick={() => handleSave()}>保存</SaveButton>
                                </Grid>
                            </Grid>
                        </Box>
                    </Box>
                </Zoom>
            </Modal >
        </>
    );
}

export default SaveCondition;
